<template>
  <div>
    <template v-if="productType === 'variable'">
      <transition name="fade">
        <customizer-wrapper v-if="getCustomizerOpen"/>
      </transition>
      <Summary/>
      <default-modal v-if="getVariationsCount"/>
    </template>
    <fabric-dialog v-if="openFabricModal" :open="openFabricModal" @close="openFabricModal = false" />
  </div>
</template>

<script>
import CustomizerWrapper from "@/components/customizer/CustomizerWrapper";
import Summary from "@/components/customizer/Summary";
import DefaultModal from '@/components/customizer/misc/DefaultDialog'
import FabricDialog from '@/components/customizer/misc/FabricDialog'
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "Customizer",
  components: {CustomizerWrapper, Summary, DefaultModal, FabricDialog},
  mounted() {
    const element = document.querySelector("#customizer-container");
    this.productType = element.getAttribute('data-product-type')
    if (element && this.productType === 'variable') {
      this.setProductId(element.dataset.product)
      if (this.hasURLParams && !this.hasURLOpenParam && element.getAttribute('data-product-view')) {
        this.getURLArguments()
        this.fetchProduct(element.dataset.product).then(() => {
          this.getURLArguments()
          this.fetchVariation(this.getOptions)
        })
      } else {
        this.fetchProduct(element.dataset.product).then(() => {
          this.fetchVariation(null).then(() => {
            if (this.hasURLParams && this.hasURLOpenParam) {
              this.setCustomizerOpen(true)
            }
          })
        })
      }
    }

    const icons = document.querySelectorAll('.product-description-box.empty-config .open-customizer.inner-d')
    const quickView = document.querySelector('.quickview-wrap')

    if (icons) {
      icons.forEach((icon) => {
        icon.addEventListener('click', () => {
          if (quickView) {
            window.location.href = element.getAttribute('data-product-url') + '?openCustomizer'
          } else if (this.getProduct && !document.body.classList.contains('customizer-opened') && !document.body.classList.contains('catalog-opened') && !this.openFabricModal) {
            this.setCustomizerOpen(true)
          }
        })
      })
    }

    const fabricButton = document.getElementById('openFabricModal')
    if (fabricButton) {
      fabricButton.addEventListener('click', () => {
        this.openFabricModal = true
      })
    }
  },
  computed: {
    ...mapGetters({
      getLoading: 'customizer/getLoading',
      getCustomizerOpen: 'customizer/getCustomizerOpen',
      getAttributes: 'customizer/getAttributes',
      getOptions: 'customizer/getOptions',
      getProduct: 'customizer/getProduct'
    }),
    hasURLParams() {
      return !!window.location.search
    },
    hasURLOpenParam() {
      if (!window.location.search) {
        return
      }
      const urlParams = new URLSearchParams(window.location.search)

      return urlParams.has('openCustomizer')
    },
    getVariationsCount() {
      if (this.getProduct && this.getProduct.product) {
        return !!this.getProduct.product.variations
      }
      return false
    }
  },
  watch: {
    getCustomizerOpen(n) {
      if (n) {
        document.getElementsByTagName('html')[0].style.overflow = "hidden";
        document.body.classList.add('customizer-opened')
      } else {
        document.getElementsByTagName('html')[0].style.removeProperty('overflow')
        document.body.classList.remove('customizer-opened')
      }
    },
    openFabricModal(n) {
      if (n) {
        document.getElementsByTagName('html')[0].style.overflow = "hidden";
        document.body.classList.add('catalog-opened')
      } else {
        document.getElementsByTagName('html')[0].style.removeProperty('overflow')
        document.body.classList.remove('catalog-opened')
      }
    }
  },
  methods: {
    ...mapActions({
      fetchProduct: 'customizer/fetchProduct',
      fetchVariation: 'customizer/fetchVariation'
    }),
    ...mapMutations({
      setOption: 'customizer/setOption',
      setOptionGroup: 'customizer/setOptionGroup',
      setOptionFabricV: 'customizer/setOptionFabricV',
      setProductId: 'customizer/setProductId',
      setCustomizerMode: 'customizer/setCustomizerMode',
      setCustomizerOpen: 'customizer/setCustomizerOpen'
    }),
    getURLArguments() {
      const queryString = window.location.search
      if (!queryString) {
        return
      }

      const urlParams = new URLSearchParams(queryString)

      const entries = urlParams.entries()
      let attributesCount = 0

      for (const entry of entries) {
        if (entry[0].includes('attribute_pa_')) {
          const key = entry[0].replace('attribute_', '')
          this.setOption({id: key, data: entry[1]})
          attributesCount++;
        }
      }

      if (this.getAttributes && this.getAttributes.pa_tkanina) {
        const fabric = this.getOptions.pa_tkanina
        const attributes = this.getAttributes.pa_tkanina.find(color => color.id === fabric)
        if (attributes) {
          this.setOptionGroup(attributes.group.id)
        }
      }

      // this.fetchVariation()
      //

      //
      this.setCustomizerMode('edit')

      // this.setProduct(this.getProductA)
    }

  },
  data() {
    return {
      openFabricModal: false,
      productType: 'variable'
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

button:focus {
  outline: none;
}

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.simplebar-content:before,
.simplebar-content:after {
  content: ' ';
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  left: 0;
  right: 0;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: '';
  background: #999;
  border-radius: 7px;
  left: 2px;
  right: 2px;
  width: 3px;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

</style>
